import React from 'react'

/** Wrapper for main content: max width + consistent padding. */
export default function PageShell({ children, className = '', maxWidth = 'max-w-6xl' }) {
  return (
    <div className={`mx-auto w-full ${maxWidth} px-4 py-6 sm:px-6 sm:py-8 ${className}`}>
      {children}
    </div>
  )
}
